export enum PRODUCT_TYPE_NAME {
  EXPERIENCES = 'experiences',
  DINING = 'dining',
  SHOPPING = 'shopping',

  /* FOOD = 'food',
  DRINK = 'drink',
  RETAIL = 'retail', */
}
